import React from 'react';
import { twMerge } from 'tailwind-merge';

import { TextArea as TextAreaBase } from '../TextArea';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  label: string;
  explanation?: string;
  name: string;
}

export function Textarea(props: Props) {
  const { className, label, explanation, name, ...rest } = props;

  return (
    <label className={twMerge('block', 'w-full', className)} htmlFor={name}>
      <div className="flex flex-col gap-1">
        <div className="font-bold text-white text-sm">{label}</div>
        {explanation && (
          <div className="text-neutral-400 text-sm">{explanation}</div>
        )}
      </div>
      <div className="mt-1">
        <TextAreaBase id={name} name={name} className="w-full" {...rest} />
      </div>
    </label>
  );
}
